import './_article-item-list.scss';

export default function ArticleItemList() {
  const $wrapperList = document.querySelectorAll('.article-item-list');
  const currentDomain = window.location.hostname;

  if($wrapperList.length) {
    $wrapperList.forEach($wrapper => {
      const $links = $wrapper.querySelectorAll('.list .item .text a');
      $links.forEach($link => {
        const linkUrl = $link.getAttribute('href') as string;
        const isLinkAbsolute = linkUrl.startsWith('http');
        const isLinkExternal = Boolean(isLinkAbsolute && !linkUrl.includes(currentDomain));
        isLinkExternal && $link.classList.add('external');
      });
    });
  }
}
